module.exports = __webpack_public_path__ + "static/img/black-board-bottom.7824006e.jpg";